import reducers from './reducers';

// Named exports for types, selectors, and operations
export { default as promosTypes } from './types';
export { default as promosSelectors } from './selectors';
export { default as promosOperations } from './operations';

// Default export is the reducers
export default reducers;
